
export enum AlertAnswer {
  Unknown = 1,
  Valid = 2,
  Suspicious = 3
}
